import BaseApi from "../../BaseApi";
import {headers} from "../../ApiSettings";

class Net extends BaseApi {
    constructor() {
        super({suffix: ""});
    }

    GetAllTori(params) {
        return this.httpService.get("Definition/all-net", {headers, params})
    }

    EditPriceTori(data) {
        return this.httpService.put("Definition/set-price-net", data, {headers})
    }

    EditTori(data) {
        return this.httpService.put("Definition/update-net", data, {headers})
    }

    InsertToriData(data) {
        return this.httpService.post("Definition/insert-net", data, {headers})
    }

    deleteTori(data) {
        return this.httpService.delete("Definition/delete-net", {headers, data})
    }

    getRelationNet(params) {
        return this.httpService.get("Definition/relation-net", {headers, params})
    }

    disableTori(data) {
        return this.httpService.put("Definition/disable-net", data, {headers})
    }

}

const NetService = new Net();
export default NetService;

